<template>

  <button
    type="button"
    class="btn-next"
    :disabled="disabled"
    @click="$parent.next"
    @mouseenter="hover=true"
    @mouseleave="hover=false"
  >
    <span v-if="$parent.prevText">{{$parent.prevText}}</span>
    <svg
      v-else
      class="icon static-icon"
      aria-hidden="true"
    >
      <use :xlink:href="hoverPath"></use>
    </svg>
  </button>

</template>
<script>
export default {
  data () {
    return {
      hover: false
    }
  },
  computed: {
    disabled () {
      return this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
    },
    hoverPath () {
      if (this.hover && !this.disabled) {
        return '#icon-fanye'
      }
      return '#icon-fanyezuo'
    }
  }
}
</script>
<style lang="less" scoped>
.icon {
  transform: rotate(180deg);
}
</style>
